import { render, staticRenderFns } from "./inputcheck.vue?vue&type=template&id=6aafb6e6"
import script from "./inputcheck.js?vue&type=script&lang=js&external"
export * from "./inputcheck.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports